(() => {
  const root = document.querySelector('[data-sulmy-purchase-root]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const variants = JSON.parse(root.querySelector('[data-purchase-variants]').textContent);
  const mainButton = document.getElementById('product-add-to-cart');
  const form = mainButton && mainButton.form;
  if (!form) return;
  const section = root.closest('.shopify-section') || document;
  const offer = section.querySelector('[data-sulmy-offer]');
  const bar = root.querySelector('[data-mobile-buy]');
  const mobileButton = bar.querySelector('[data-mobile-submit]');
  const mobilePrice = bar.querySelector('[data-mobile-price]');
  const media = window.matchMedia('(max-width: 767px)');
  let scheduled = false;
  let buying = false;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(cents / 100);
  function update() {
    scheduled = false;
    const idInput = form.elements.namedItem('id');
    const variant = variants.find(v => String(v.id) === String(idInput && idInput.value));
    const quantityInput = form.elements.namedItem('quantity');
    const quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
    mobileButton.disabled = buying || mainButton.disabled || !variant || !variant.available;
    mobileButton.textContent = buying ? root.dataset.processing : (mobileButton.disabled ? mainButton.textContent.trim() : root.dataset.buyNow);
    if (variant) mobilePrice.textContent = money(variant.price);
    if (!offer) return;
    const total = variant ? variant.price * quantity : 0;
    const tier = root.dataset.currency === 'USD' ? (total >= 60000 ? [150,600,'S150'] : total >= 50000 ? [100,500,'S100'] : total >= 30000 ? [60,300,'S60'] : null) : null;
    const title = tier ? root.dataset.offerTemplate.replace('[saving]', money(tier[0]*100)).replace('[minimum]', money(tier[1]*100)).replace('[code]',tier[2]) : root.dataset.offerTitle;
    offer.querySelector('[data-offer-title]').textContent = title;
    const copy = offer.querySelector('[data-copy-offer]');
    copy.hidden = !tier;
    copy.dataset.code = tier ? tier[2] : '';
    copy.textContent = root.dataset.copy;
    offer.hidden = location.href.includes('flash-sale');
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  function visibility() {
    const checkout = form.querySelector('.productView-payment');
    const target = checkout && checkout.getClientRects().length ? checkout : mainButton;
    const rect = target.getBoundingClientRect();
    const visible = media.matches && rect.width > 0 && rect.height > 0 && rect.bottom <= 0;
    bar.hidden = !visible;
    document.body.classList.toggle('sulmy-mobile-buy-enabled',visible);
  }
  mobileButton.addEventListener('click', async () => {
    if (buying || mainButton.disabled || !form.reportValidity()) return;
    buying = true;
    const error = root.querySelector('[data-mobile-buy-error]');
    error.hidden = true;
    update();
    try {
      const data = new FormData(form);
      data.delete('return_to');
      const route = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const response = await fetch(route + 'cart/add.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || root.dataset.error);
      window.location.assign(route + 'checkout');
    } catch (failure) {
      error.textContent = failure.message || root.dataset.error;
      error.hidden = false;
      buying = false;
      update();
    }
  });
  if (offer) offer.querySelector('[data-copy-offer]').addEventListener('click', async event => {
    const button = event.currentTarget;
    let copied = false;
    try { await navigator.clipboard.writeText(button.dataset.code); copied = true; }
    catch {
      const input = document.createElement('textarea');
      input.value = button.dataset.code;
      input.setAttribute('readonly','');
      input.style.cssText = 'position:fixed;left:-9999px;top:0';
      document.body.appendChild(input);
      input.select();
      copied = document.execCommand('copy');
      input.remove();
      button.focus();
    }
    button.textContent = copied ? root.dataset.copied : button.dataset.code;
    offer.querySelector('[data-offer-status]').textContent = copied ? root.dataset.copied : button.dataset.code;
  });
  section.addEventListener('change',schedule);
  section.addEventListener('input',schedule);
  const price = document.getElementById('product-price-' + root.dataset.productId);
  if (price) new MutationObserver(schedule).observe(price,{childList:true,subtree:true,characterData:true});
  new MutationObserver(schedule).observe(mainButton,{attributes:true,childList:true,subtree:true});
  let visibilityScheduled = false;
  function scheduleVisibility() {
    if (visibilityScheduled) return;
    visibilityScheduled = true;
    requestAnimationFrame(() => {
      visibilityScheduled = false;
      visibility();
    });
  }
  window.addEventListener('scroll',scheduleVisibility,{passive:true});
  window.addEventListener('resize',scheduleVisibility,{passive:true});
  window.addEventListener('pageshow',scheduleVisibility);
  window.addEventListener('load',scheduleVisibility);
  section.addEventListener('change',scheduleVisibility);
  if (window.ResizeObserver) new ResizeObserver(scheduleVisibility).observe(section === document ? document.documentElement : section);
  media.addEventListener('change',visibility);
  update(); visibility();
})();
